export default "__VITE_ASSET__BlgsT4Y4__ 640w, __VITE_ASSET__Dj$CJvjh__ 1024w, __VITE_ASSET__ssufDpp8__ 1280w";